import { lazy } from 'react';
import ApplicationSuccess from '../pages/ApplicationSignUp/ApplicationSuccess';
import CancelPayment from '../pages/CancelPayment';
import DeclinePayment from '../pages/DeclinePayment';
import RedirectPage from '../pages/RedirectPage';
const PaymentSuccess = lazy(() => import('../pages/PaymentSuccess'));
const CourseRegistration = lazy(() => import('../pages/CourseRegistration'));
const ApplicationRegistration = lazy(() => import('../pages/ApplicationSignUp'));
const Home = lazy(() => import('../pages/Home'));
const SignUp = lazy(() => import('../pages/SignUp'));
const SignIn = lazy(() => import('../pages/SignIn'));
const ResetPassword = lazy(() => import('../pages/ResetPassword'));
const Course = lazy(() => import('../pages/CourseDetail'));
const GhostLogin = lazy(() => import('../pages/GhostLogin'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Payment = lazy(() => import('../pages/Payment'));
const TermsOfUse = lazy(()=>import('../pages/TermsofUse'))

export const routes = [
    { path: '/home', Component: Home, title: "Home" },
    // { path: '/course/:cid', Component: Course, title: "Course" },
    { path: '/404', Component: NotFound, title: "404" },
];

export const commonRoutes = [
    { path: '/apply/:id', Component: ApplicationRegistration, title: "Application Registration" },
    { path: '/course/:cid', Component: Course, title: "Course" },
    { path: '/auth_token/:userId/:token', Component: GhostLogin, title: "Authorization" },
    { path: '/course/:cid/:isloggedin', Component: Course, title: "Course" },
    { path: '/payment', Component: Payment, title: "Payment" },
    { path: '/application-submited', Component: ApplicationSuccess, title: "Application Success" },
    { path: '/payment-success/:code', Component: PaymentSuccess, title: "Payment Success" },
    { path: '/payment-success', Component: PaymentSuccess, title: "Payment Success" },
    { path: '/cancel-payment', Component: CancelPayment, link: "https://precollege.usc.edu/", title: "Cancel Payment" },
    { path: '/decline-payment', Component: DeclinePayment, link: "https://precollege.usc.edu/", title: "Decline Payment" },
    { path: '/apply', Component: RedirectPage, link: "https://precollege.usc.edu/online-programs/", title: "Application Registration" },
    { path: '/terms-of-use', Component: TermsOfUse, title: "Terms of Use" },
];

export const publicRoutes = [
    { path: '/course-payment/:id', Component: CourseRegistration, title: "Course Registration" },
    // { path: '/apply/:id', Component: ApplicationRegistration, title: "Application Registration" },
    { path: '/signup/:token', Component: SignUp, title: "Sign Up" },
    { path: '/signin', Component: SignIn, title: "Sign In" },
    { path: '/signin/:token', Component: SignIn, title: "Sign In" },
    { path: '/reset-password/:token', Component: ResetPassword, title: "Reset Password" },
];
